// extracted by css-extract-rspack-plugin
export default {"condensed":"BorderBox-module__condensed__yzHjU","creating":"BorderBox-module__creating__epB83"};